<template>
  <div class="form-group" :class="{ 'has-error': error }">
    <label :for="$attrs.id" :style="labelFontSize"
      ><strong>{{ label }}</strong></label
    >
    <div class="input-group col-md-3">
      <date-picker
        :id="$attrs.id"
        :config="dateConfig"
        v-model="localValue"
        :wrap="true"
        class="form-control"
        @dp-hide="bubbleup"
      ></date-picker>
      <div class="input-group-addon">
        <span class="glyphicon glyphicon-calendar"></span>
      </div>
    </div>
    <span v-show="error" class="help-block">{{ error }}</span>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Date],
      },
      label: {
        type: String,
      },
      isLargeFont: {
        type: Boolean,
        default: true,
      },
      error: {
        type: String,
        default: '',
      },
      changeOnHide: {
        type: Boolean,
        default: false,
      },
      dateConfig: {
        type: Object,
      },
    },
    methods: {
      bubbleup() {
        if (this.changeOnHide) {
          this.$emit('update', this.value);
        }
      },
    },
    computed: {
      localValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
      labelFontSize() {
        const fontSize = this.isLargeFont ? 20 : 16;
        return {
          fontSize: `${fontSize}px`,
        };
      },
    },
  };
</script>
<style lang="scss" scoped>
  label {
    &.required::after {
      content: '*';
      color: red;
    }
  }
</style>
